import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { RPERolActividades } from './rpe-rol-actividades.model';

@Injectable({
  providedIn: 'root'
})
export class RPERolActividadesService {
  url: string;
  token: string;
  endpoint = 'rpeRoles';

  constructor(private http: HttpClient) {}

  addRPERolActividades(
    rpeRolActividades: RPERolActividades
  ): Observable<RPERolActividades> {
    return this.http.post<RPERolActividades>(`${this.url}/${this.endpoint}/`, {
      rol: {
        ...rpeRolActividades.rol,
        fecha_alta: rpeRolActividades.rol.fecha_alta.toISOString().split('T')[0]
      },
      actividades_id: rpeRolActividades.actividades_id
    });
  }
}
